import { useCallback } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import { getProvinceCodeTranslationKey } from "@ui/utils/getProvinceCodeTranslationKey";

import { useConfig } from "@jti/app-context/useConfig";
import type { Address, AddressStored } from "@jti/fe-common";
import { isAddressFormExtendedWithProvince } from "@jti/fe-common";

type Options = {
  provinceCode?: string;
};

export const useApplyAddressOverrides = () => {
  const { __ } = useTranslations();
  const config = useConfig();

  const applyAddressOverrides = useCallback(
    <T extends Address | AddressStored>(address: T, options: Options): T => {
      const isFormExtendedWithProvince = isAddressFormExtendedWithProvince(config.addressFormVariant);

      if (isFormExtendedWithProvince && options.provinceCode) {
        return {
          ...address,
          provinceName: __(getProvinceCodeTranslationKey(options.provinceCode), [], options.provinceCode),
        };
      }

      return address;
    },
    [config.addressFormVariant, __]
  );

  return { applyAddressOverrides };
};
